// extracted by mini-css-extract-plugin
export default {"root":"LoadingIndicator_root__qXYaX","ellipsis1":"LoadingIndicator_ellipsis1__yE83c","ellipsis2":"LoadingIndicator_ellipsis2__d401A","ellipsis3":"LoadingIndicator_ellipsis3__yR4Pz"};